import { Popup } from "./popup";

export type { PopupProps } from "./popup";

export default Popup;
